
  import * as ipxRuntime$lhD85eBHInZ_qek9Pa_45IJJ4NhL3j9iVqBuQb_SGyldQ from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_better-sqlite3@12.4.1__ioredis@5.8.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as ipxRuntime$JnEoP5ZmNEi7029o1RfQNhHRXNqzsjkpBDAn6SmZ5Gs from '/app/app/image-provider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 375,
    "sm": 768,
    "md": 1024,
    "lg": 1240,
    "xl": 1440,
    "xxl": 1920,
    "2xl": 1536,
    "xxxl": 2560
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$lhD85eBHInZ_qek9Pa_45IJJ4NhL3j9iVqBuQb_SGyldQ, defaults: {"maxAge":31536000} },
  ['ipx']: { provider: ipxRuntime$JnEoP5ZmNEi7029o1RfQNhHRXNqzsjkpBDAn6SmZ5Gs, defaults: undefined }
    }
  }
